import { NavLink } from 'react-router';
import { CalendarCheckIcon, HouseIcon, SquaresFourIcon } from '@phosphor-icons/react';
import { useStudio } from './studio-data';

/**
 * Floating glass navigation (icon above label, the current page in a lighter pill).
 * Hides while the keyboard is open.
 * The assistant lives in the header; «Записаться» is pinned above (StickyBook).
 */
export function BottomNav() {
  const studio = useStudio();
  const base = `/s/${studio.slug}`;
  const items = [
    { to: `${base}/`, label: 'Главная', icon: HouseIcon, end: true },
    { to: `${base}/services`, label: 'Услуги', icon: SquaresFourIcon, end: false },
    { to: `${base}/my`, label: 'Моя запись', icon: CalendarCheckIcon, end: false },
  ];
  return (
    <nav className="bottom-nav glass" aria-label="Основная навигация">
      <ul className="bottom-nav__list glass__content">
        {items.map((item) => (
          <li key={item.to}>
            <NavLink to={item.to} end={item.end} className="bottom-nav__link">
              {({ isActive }) => (
                <>
                  <item.icon size={22} weight={isActive ? 'fill' : 'regular'} aria-hidden />
                  <span>{item.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
